import type { TelemetryDiagnostics } from '../../domain/telemetry/processed/TelemetryDiagnostics'
import type { Finding } from '../finding'

export function imuVibrationFinding(
  diagnostics: TelemetryDiagnostics | null | undefined
): Finding | null {
  if (!diagnostics?.imuIgnoredForVibration) return null
  return {
    check: 'imuVibration',
    level: 'stream',
    aspect: 'imu',
    verdict: 'unusable',
    reason:
      'The IMU is corrupted by vibration, so lean and acceleration come from GPS',
  }
}
